import axios from "./axios";
import { setHeaders } from "./baseApi";
import { apiPaths } from "./baseApi";

/**
 * @param {string} [context] - Contexte facultatif
 * @returns {Promise<any>}
 */

// Phase 3 & 4----------------------------------------------------------------------------------------

// créer un compte bancaire
export const createBankAccount = async (payload, context) => {
  const response = await axios.post(
    apiPaths.baseUrl + `/api/bank/create`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// modifier un compte bancaire
export const updateBankAccount = async (id, payload, context) => {
  const response = await axios.put(
    apiPaths.baseUrl + `/api/bank/${id}`,
    payload,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// récupérer les compte bancaires par id_paymentSetting
export const getBankAccountsByPaymentSettingId = async (
  id_paymentSetting,
  context,
) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/bank/all/${id_paymentSetting}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

//  récupérer un compte bancaire
export const getBankAccountById = async (id, context) => {
  const response = await axios.get(
    apiPaths.baseUrl + `/api/bank/getBank/${id}`,
    { headers: setHeaders(context) },
  );
  return response.data;
};

// supprimer un compte bancaire
export const deleteBankAccount = async (id, context) => {
  const response = await axios.delete(apiPaths.baseUrl + `/api/bank/${id}`, {
    headers: setHeaders(context),
  });
  return response.data;
};
